import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-forest text-white/90 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/brand/ofr-mark.png" alt="Our First Realty" className="w-11 h-11 rounded-md object-cover" />
            <div className="leading-tight">
              <div className="font-heading font-bold text-xl">Our First Realty</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-gold mt-0.5">Your first step to the right property</div>
            </div>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            Hyderabad's real estate aggregator. We verify. We market. We close. Builders build — we do everything else.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/70">
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> Kompally · Kukatpally · Madhapur</div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> +91 90109 03620</div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> info@ourfirstrealty.com</div>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-bold text-gold uppercase text-xs tracking-[0.2em] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/projects" className="hover:text-gold">All Projects</Link></li>
            <li><Link to="/projects?type=apartment" className="hover:text-gold">Apartments</Link></li>
            <li><Link to="/projects?type=independent%20house" className="hover:text-gold">Independent Houses</Link></li>
            <li><Link to="/projects?type=villa" className="hover:text-gold">Villas</Link></li>
            <li><Link to="/emi" className="hover:text-gold">EMI Calculator</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-gold uppercase text-xs tracking-[0.2em] mb-4">For Builders</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/for-builders" className="hover:text-gold">List Your Project</Link></li>
            <li><Link to="/for-builders#list-project" className="hover:text-gold">Sales &amp; Marketing Support</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © {new Date().getFullYear()} Our First Realty LLP · RERA Agent Registered · Hyderabad, Telangana
      </div>
    </footer>
  );
}
